import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { MdaSelectOption, ReviewStatus } from "./mda-types";

interface MdaReviewStatusFilterProps {
  value: ReviewStatus;
  options: MdaSelectOption[];
  onChange: (
    event: React.MouseEvent<HTMLElement>,
    value: ReviewStatus | null,
  ) => void;
}

const MdaReviewStatusFilter = ({
  value,
  options,
  onChange,
}: MdaReviewStatusFilterProps) => (
  <Stack spacing={0.8}>
    <Typography variant="caption" sx={{ color: "#24344d", fontWeight: 700 }}>
      Review Status
    </Typography>
    <ToggleButtonGroup
      exclusive
      value={value}
      onChange={onChange}
      size="small"
      sx={{ display: "flex" }}
    >
      {options.map(({ value: optionValue, label }) => (
        <ToggleButton
          key={optionValue}
          value={optionValue as ReviewStatus}
          sx={{
            flex: 1,
            borderColor: "#d9e1ed",
            color: "#46566e",
            textTransform: "none",
            whiteSpace: "nowrap",
            px: 1.2,
            "&.Mui-selected": {
              color: "#1769ff",
              backgroundColor: "#f3f7ff",
              borderColor: "#8bb2ff",
            },
          }}
        >
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Stack>
);

export default MdaReviewStatusFilter;
